const ServiceTypes = {
  Config: Symbol('Config'),
  Ssr: Symbol('Ssr'),
  Navigation: Symbol('Navigation'),
  Grpc: Symbol('Grpc'),
  I18N: Symbol('I18N'),
};

export default ServiceTypes;
